import getEnvConfig from "@efcloud/el-b2b-get-env-config"
import deepmerge from "deepmerge"

export default deepmerge.all([{}, getEnvConfig("platformAuthConfig"), {
  autoStart: false,
  autoRedirect: false
}])
